var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomingCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.404 14.5001C1.14783 14.5001 0.933167 14.4134 0.76 14.2401C0.586667 14.0669 0.5 13.8522 0.5 13.5961V5.75005C0.5 5.53755 0.571917 5.35939 0.71575 5.21555C0.859584 5.07189 1.03775 5.00005 1.25025 5.00005C1.46292 5.00005 1.641 5.07189 1.7845 5.21555C1.92817 5.35939 2 5.53755 2 5.75005V11.9463L12.9193 1.02705C13.0578 0.888555 13.2318 0.817721 13.4413 0.814555C13.6509 0.811388 13.8282 0.882221 13.973 1.02705C14.1178 1.17189 14.1903 1.34747 14.1903 1.5538C14.1903 1.7603 14.1178 1.93597 13.973 2.0808L3.05375 13.0001H9.25C9.4625 13.0001 9.64067 13.072 9.7845 13.2158C9.92817 13.3596 10 13.5378 10 13.7503C10 13.963 9.92817 14.1411 9.7845 14.2846C9.64067 14.4282 9.4625 14.5001 9.25 14.5001H1.404Z",
    fill: "#F44649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCallIcon);
export default __webpack_public_path__ + "static/media/incomingCallIcon.f72a226b678f60cf8858935b4a481c6b.svg";
export { ForwardRef as ReactComponent };